import type { ILocalizedInformation } from '@inter-ikea-kompis/types';

import type IZipInTranslations from '../types/IZipInTranslations.js';

type IZipInToastMessage = {
	label: string;
};

export default class ZipInToastMessage {
	public static getZipCodeToastLabel(
		localizedInformationOrTranslations: ILocalizedInformation | IZipInTranslations,
		zipCode: string
	): IZipInToastMessage {
		const zipCodeLabel =
			'translations' in localizedInformationOrTranslations
				? localizedInformationOrTranslations.translations.zipCodeSelectedMessage
				: localizedInformationOrTranslations.zipCodeSelectedMessage;

		const stringToReplace = 'zip_code';
		const zipCodeToUpperCase = zipCode.toUpperCase();
		const label = zipCodeLabel
			.replace(`[[${stringToReplace}]]`, zipCodeToUpperCase)
			.replace(`{{${stringToReplace}}}`, zipCodeToUpperCase);

		return {
			label
		};
	}
}
